/**
 * A file's bytes as standard base64, on one line: the part of FileReader's data URL
 * after its `data:<type>;base64,` prefix, which the API does not take.
 */
export const readFileAsBase64 = (file) =>
    new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => {
            const dataUrl = String(reader.result);
            resolve(dataUrl.slice(dataUrl.indexOf(',') + 1));
        };
        reader.onerror = () => reject(reader.error);
        reader.readAsDataURL(file);
    });
